export default{

    measures:{
        importCsv: 'Insert from fat meter',
        chooseFatMeter: 'Select a fat-meter',
    }
}